import type { MessageOpenTarget } from "../types"

export const getPanelTokenFromUrl = (panelUrl?: string) => {
  if (!panelUrl) return ""
  try {
    return new URL(panelUrl, window.location.origin).searchParams.get("panel_token") || ""
  } catch {
    return ""
  }
}

/**
 * Append the direct-message deep-link params the Messages panel understands.
 * Renderer-agnostic: callers decide whether the URL needs a Daily-public-origin rewrite first.
 */
export const withMessagesOpenTarget = (panelUrl: string | undefined, target?: MessageOpenTarget) => {
  if (!panelUrl || typeof window === "undefined") return panelUrl
  if (!target) return panelUrl
  try {
    const parsedUrl = new URL(panelUrl, window.location.origin)
    if (target.threadId) parsedUrl.searchParams.set("open_thread", target.threadId)
    if (target.recipientIdentityKey) parsedUrl.searchParams.set("open_identity", target.recipientIdentityKey)
    return parsedUrl.toString()
  } catch {
    return panelUrl
  }
}
